import React from 'react';
import * as fmt from '../../lib/format';

interface Props {
  values: number[];
  /** CSS colour of the line; the area under it is the same colour, faint. */
  color?: string;
}

const W = 100;
const H = 28;
const PAD = 3;

// A small trend: one point per day. Decoration only: the number and the change beside it say the same in words.
export default function Sparkline({ values, color = '#2563eb' }: Props) {
  if (values.length < 2) return <div className="h-7" aria-hidden />;
  const top = Math.max(...values, 1);
  const x = (i: number) => (i / (values.length - 1)) * W;
  const y = (v: number) => H - PAD - (v / top) * (H - PAD * 2);
  const line = values.map((v, i) => `${fmt.decimal(x(i))},${fmt.decimal(y(v))}`).join(' ');
  const last = values.length - 1;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="block h-7 w-full overflow-visible" preserveAspectRatio="none" aria-hidden focusable="false">
      <polygon points={`0,${H} ${line} ${W},${H}`} fill={color} opacity={0.1} />
      <polyline points={line} fill="none" stroke={color} strokeWidth={1.6} vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(last)} cy={y(values[last])} r={2.2} fill={color} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
